import SettingsIcon from '@mui/icons-material/Settings';
import HallintaDashboard from './HallintaDashboard';

export default {
    list: HallintaDashboard,
    icon: SettingsIcon,
};
